module.exports = __webpack_public_path__ + "static/media/add.109a1cf8.svg";